import React from 'react';

import { Checkbox } from '#/components/ui';

const BooleanFilter = ({ label, value, setSearch, queryKey }) => {
    const handleChange = checked => {
        setSearch(prev => {
            const newParams = { ...prev };
            newParams[queryKey] = checked ? true : '';
            return newParams;
        });
    };

    return (
        <div className='flex items-center gap-2 pl-8 pb-4'>
            <Checkbox id={queryKey} checked={value === true} onCheckedChange={handleChange} />
            <label htmlFor={queryKey} className='text-sm text-gray800'>
                {label}
            </label>
        </div>
    );
};

export { BooleanFilter };
